export const env = "dev";

export const appSlug: string = "whats-correct";
